import moment from "moment-timezone";
import 'moment/locale/pt-br';

import { is } from "./object";

export function parse(date, format) {
    let parsed = date;

    if (is(date, "string")) {
        parsed = moment(date, format ? format : undefined);
    } else if (is(date, Date)) {
        parsed = moment(date);
    }

    return parsed;
}

export function format(date, format) {
    if (is(date, "string")) date = parse(date);

    let newFormat = "DD/MM/YYYY HH:mm";

    if (date.hours() === 0 && date.minutes() === 0) newFormat = "DD/MM/YYYY";

    return date.format(format || newFormat);
}

export function dateFormat(date) {
    const year = date.format("YYYY");
    const month = date.format("MM");
    const day = date.format("DD");
    const hour = date.format("HH");
    const minute = date.format("MM");
    const second = date.format("ss");

    return { year, month, day, hour, minute, second };
}

function returnDateDifference(date){
    const option = {
        year: 'numeric',
        month: 'long',
        weekday: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }
    let data_atual = new Date();
    let data = new Date(date)
    let diffTime = Math.abs(data.setDate(data.getDate())-data_atual);
    let diff;
    diff = Math.ceil((diffTime / (1000 * 60 )))
    if(diff < 60) return {data:(diff>1)?(diff+' minutos'):(diff+' minuto'),temp:diff} 
    let string = new Date(date).toLocaleDateString('pt-br',option)
    return {data:string.charAt(0).toUpperCase()+string.slice(1),temp:diff}
}

export function returnDate(date){
    let datafinal = date.replaceAll('/','-').replaceAll(' ','T')+':00'
    let dataF = datafinal.split('T')[0]
    dataF = dataF.split('-')
    let dataR = `${dataF[2]}-${dataF[1]}-${dataF[0]}`
    return returnDateDifference(dataR+'T'+datafinal.split('T')[1])
}

const optionsDate={year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit',second:'2-digit'}

function getHours(point){
    if(point=='ini'){return '00:00:00'}
    else if(point=='fim'){return '23:59:59'}
    else return point
    
}

export function formatDate(date,point){
    const data = new Date(date)
    let aux = data.toLocaleTimeString("pt-BR",optionsDate).replaceAll(',','').split(' ')
    let [dia,mes,ano] = aux[0].split('/')
    return `${ano}-${mes}-${dia} ${getHours(point?point:aux[1])}`
}

export function formatTime(moment){
    const data = new Date(moment)
    return data.toLocaleTimeString("pt-BR",{hour: '2-digit', minute: '2-digit'})
}

export function dateInTimezone(){
    let data = moment().format()
    data = moment.tz(data, "America/Sao_Paulo").format('LLL')
    return formatDate(data)
}

export function dateValidNota(bipe){
    let cod = bipe.substring(2,6)
    let [ano,mes,dia] = dateInTimezone().split(' ')[0].split('-')
    let anoCode = cod.substring(0,2)
    let mesCode = cod.substring(2,4)
    ano = ano.substring(2,4)
    if(anoCode>ano) return false
    else if(anoCode==ano) {
        if(mesCode>mes) return false
    }
    return true
}

export function toParsableDate(date){
    if(date){
    const splitedDateAndHour = date.split(" ")
    const [day,month,year] = splitedDateAndHour[0].split("/")
    return `${year}-${month}-${day} ${splitedDateAndHour[1]}`
}
    return date
}

export function returnDefaultDate(date){
    try {
        let [calendar,hour] = date.split(' ')
        calendar = calendar.split('/').reverse().join('-')
        return `${calendar}T${hour}`
    }
    catch {return null}
}

export function compareDate(dateX,dateY){
    try {
        return new Date(returnDefaultDate(dateX)).getTime() - new Date(returnDefaultDate(dateY)).getTime()
    }
    catch { return null}
}

export function intToStringDate(date){
    let data = String(date)
    return data.slice(0,2)+":"+data.slice(2)
}